/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelerProfileUpdateRequest
 */
export interface TravelerProfileUpdateRequest {
    /**
     * Updated traveler profile text
     * @type {string}
     * @memberof TravelerProfileUpdateRequest
     */
    travelerProfile: string;
}

/**
 * Check if a given object implements the TravelerProfileUpdateRequest interface.
 */
export function instanceOfTravelerProfileUpdateRequest(value: object): value is TravelerProfileUpdateRequest {
    if (!('travelerProfile' in value) || value['travelerProfile'] === undefined) return false;
    return true;
}

export function TravelerProfileUpdateRequestFromJSON(json: any): TravelerProfileUpdateRequest {
    return TravelerProfileUpdateRequestFromJSONTyped(json, false);
}

export function TravelerProfileUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelerProfileUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'travelerProfile': json['traveler_profile'],
    };
}

export function TravelerProfileUpdateRequestToJSON(json: any): TravelerProfileUpdateRequest {
    return TravelerProfileUpdateRequestToJSONTyped(json, false);
}

export function TravelerProfileUpdateRequestToJSONTyped(value?: TravelerProfileUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'traveler_profile': value['travelerProfile'],
    };
}

